import { useContext } from 'react';
import { AuthContext, type AuthContextValue } from './authContextDef';

/**
 * Hook for consuming auth state anywhere inside <AuthProvider>.
 * Throws if called outside the provider tree so misconfiguration is caught early.
 */
export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth must be used inside <AuthProvider>.');
  }
  return ctx;
}
